module.exports = __webpack_public_path__ + "dc39b5ca1da928619f1ba84142c8167b.png";